import React, { Component } from 'react'
import { Segment, Container, Header, Divider, List, Image } from 'semantic-ui-react'
import { rule, payment, work } from './../static/svgs'
import imageCartoes from './../static/cartoes.jpg'

const style = {
  marginTop: '10px',
  marginBottom: '10px',
}

export default class EmpresaComponent extends Component {
  render() {
    return (
      <Segment vertical>
        <Container>
          <Header as="h3">Empresa</Header>
          <h4>A Varais Alpha está no mercado para assegurar a excelência na venda.</h4>
          <h4>
            Trabalhamos com profissionais treinados, mão-de-obra especializada e com materiais de alta qualidade para garantir
            sempre os melhores serviços com rapidez e eficiência.
          </h4>
          <Divider as="h4" className="header" horizontal style={{ margin: '3em 0em', textTransform: 'uppercase' }}>
            Conceitos
          </Divider>
          <List bulleted>
            <List.Item>Sempre atualizados com produtos de qualidade</List.Item>
            <List.Item>Treinamento periódico de nossos profissionais</List.Item>
            <List.Item>Contato frequente com fabricantes e orgãos de qualidade</List.Item>
            <List.Item>Entrega do melhor produto, garantia e qualidade</List.Item>
          </List>
          <Divider as="h4" className="header" horizontal style={{ margin: '3em 0em', textTransform: 'uppercase' }}>
            Serviços
          </Divider>
          <List divided verticalAlign="middle">
            <List.Item style={style}>
              <Image avatar src={work} />
              <List.Content>{'Instalação Personalizada'}</List.Content>
            </List.Item>
            <List.Item style={style}>
              <Image avatar src={payment} />
              <List.Content>{'Pagamento Facilitado'}</List.Content>
            </List.Item>

            <List.Item style={style}>
              <Image avatar src={rule} />
              <List.Content>{'Produtos Feitos Sob Medida'}</List.Content>
            </List.Item>
          </List>
          <Divider as="h4" className="header" horizontal style={{ margin: '3em 0em', textTransform: 'uppercase' }}>
            Pagamento
          </Divider>
          <p style={{ fontSize: '1.33em' }}>Aceitamos todos os tipos de cartões de crédito e débito:</p>
          <p style={{ fontSize: '1.33em' }}>
            <Image src={imageCartoes} style={{ width: '20%', height: '20%' }} />
          </p>
        </Container>
      </Segment>
    )
  }
}
